import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface HistoryRequest {
  passportId: string;
  header: any;
}

@Injectable({
  providedIn: 'root'
})
export class HistoryPanelService {
  private readonly openHistorySubject = new Subject<HistoryRequest>();
  
  openHistory$ = this.openHistorySubject.asObservable();

  openHistoryPanel(passportId: string, header: any): void {
    this.openHistorySubject.next({ passportId, header });
  }
}

